export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appHead = {"meta":[{"name":"viewport","content":"width=device-width, initial-scale=1","charset":"utf-8"},{"charset":"utf-8","name":"viewport","content":"width=device-width,initial-scale=1,maximum-scale=2"}],"link":[{"rel":"preconnect","href":"https://js.sentry-cdn.com","crossorigin":"anonymous"},{"rel":"dns-prefetch","href":"https://assets.stringking.com","crossorigin":"anonymous"},{"rel":"preconnect","href":"https://assets.stringking.com","crossorigin":"anonymous"},{"rel":"dns-prefetch","href":"https://cms-static.stringking.com","crossorigin":"anonymous"},{"rel":"dns-prefetch","href":"https://sk-cms.stringking.com","crossorigin":"anonymous"},{"rel":"dns-prefetch","href":"https://images.stringking.com","crossorigin":"anonymous"},{"rel":"preconnect","href":"https://images.stringking.com","crossorigin":"anonymous"},{"rel":"icon","type":"image/x-icon","href":"https://assets.stringking.com/static/sites/stringking/icons/favicon.ico"}],"style":[{"key":"vuetify-layers-ordered","tagPriority":10,"innerHTML":"@layer vuetify-core,vuetify-components,vuetify-overrides,vuetify-utilities,vuetify-final;"}],"script":[{"key":"sentry-init","tagPriority":998,"type":"text/javascript","innerHTML":"!function(n,o){o=n.sentryConfigObj={\"release\":\"4871948\",\"initialize\":true,\"debug\":false,\"environment\":\"production\",\"sendDefaultPii\":true,\"tunnel\":\"/api-local/sentry\",\"sampleRate\":0.2,\"ignoreSpans\":[{\"op\":{}},{\"op\":\"resource.other\",\"name\":{}},{\"op\":\"resource.link\",\"name\":{}},{\"op\":{},\"name\":{}},{\"op\":{},\"name\":{}},{\"op\":\"measure\"}],\"tracing\":{\"tracesSampleRate\":0.2,\"vueOptions\":{\"tracing\":true,\"tracingOptions\":{\"hooks\":[\"mount\",\"update\"],\"timeout\":2000,\"trackComponents\":true}}}},n.sentryOnLoad=function(){n.console.log(\"Sentry LOADED!\"),Sentry.init(o)}}(window);","tagPosition":"bodyClose","crossorigin":"anonymous"},{"key":"sentry-loader","tagPriority":999,"src":"https://js.sentry-cdn.com/e09b14886f4f4820a271b7693018003f.min.js","crossorigin":"anonymous","tagPosition":"bodyClose"}],"noscript":[],"htmlAttrs":{"lang":"en"}}

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = {"enabled":false}

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = true

export const componentIslandsActive = true

export const payloadExtraction = false

export const prefetchPreloadTags = false

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"deep":false}

export const useStateDefaults = {"resetOnClear":false}

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = true

export const purgeCachedData = true

export const granularCachedData = true

export const pendingWhenIdle = false

export const alwaysRunFetchOnKeyChange = false

export const asyncCallHook = true

export const clientNodePlaceholder = false

export const tracingChannelNuxt = false

export const runtimeCompiler = false

export const hasPluginDependencies = false

export const hasParallelPlugins = true

export const hasPluginHooks = true

export const hasIslandOptOutPlugins = true